import { render, staticRenderFns } from "./TeachingUserPaperModal.vue?vue&type=template&id=21ac4e12&scoped=true"
import script from "./TeachingUserPaperModal.vue?vue&type=script&lang=js"
export * from "./TeachingUserPaperModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ac4e12",
  null
  
)

export default component.exports